'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToken = undefined;

var _noAuthApiClient = require('conversations-infrastructure/http/clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getToken = exports.getToken = function getToken(_ref) {
  var sessionId = _ref.sessionId;
  return _noAuthApiClient2.default.get('livechat/v1/pubsub/token/visitor', {
    query: { sessionId: sessionId }
  });
};